
import http from '@/assets/api/http';

export async function getEnum(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum',params,'POST');
}

// 省市区查询
export async function findAreaByParentId(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AreaInfoMisService.findAreaByParentId',params,'POST');
}

// 获取银行列表
export async function getOpenBank(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportBankService.getOpenBank',params,'POST');
}

// 获取银行支行列表
export async function getBranchBank(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportBankService.getBranchBank',params,'POST');
}

// 获取银行支行列表
export async function getBankNameByCardId(params){
    return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportBankService.bankCardCheck',params,'POST');
}

// 身份证识别
export async function getOcrIdentityInfo(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.IdentityInfoMisService.ocrIdentityInfoQuery',params,'POST');
}

// 获取系统参数
export async function getSystemParams(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.getParamValueByCode',params,'POST');
}

// 更新系统参数
export async function updateSystemParams(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.updateAdminParamValue',params,'POST');
}